import { render, staticRenderFns } from "./ReportsDefaultList.vue?vue&type=template&id=58a5e097&lang=pug"
import script from "./ReportsDefaultList.vue?vue&type=script&lang=js"
export * from "./ReportsDefaultList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports